export enum ManufacturerTypeEnum {
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed',
  Virtual = 'virtual'
}
